import { all, fork, put, take, takeLatest } from 'redux-saga/effects';

import * as apiActions from '../../../api/lendingAPI/LendingAPI.actions';
import { GET_REPAYMENT_SCHEDULE } from '../../drawDown/DrawDown.actions';

export const outstandingSaga = [fork(getRepaymentSchedule)];

function* getRepaymentSchedule() {
    yield takeLatest(GET_REPAYMENT_SCHEDULE, function* (action) {
        const { amount, offerId, productType } = action;
        yield all([
            put({
                type: apiActions.API_GET_DRAW_DOWN_REPAYMENT_SCHEDULE,
                amount: amount,
                offerId: offerId,
                productType: productType
            })
        ]);

        yield all([
            take(apiActions.API_GET_DRAW_DOWN_REPAYMENT_SCHEDULE_SUCCESS)
        ]);
    });
}
